import { render, staticRenderFns } from "./schoolHolidaysPanel.vue?vue&type=template&id=193d02ea&scoped=true"
import script from "./schoolHolidaysPanel.vue?vue&type=script&lang=js"
export * from "./schoolHolidaysPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193d02ea",
  null
  
)

export default component.exports